const TomSelectTemplate = {
    tags: {
        option: function (item, escape) {
            return `<div class="d-flex p-2"><button class="btn ${item.value} btn-sm rounded-4 px-3">${escape(item.text)}</button></div>`;
        },
        item: function (item, escape) {
            return `<div class="d-flex"><button class="btn ${item.value} btn-sm rounded-4 px-3">${escape(item.text)}</button></div>`;
        },
    },
    users: {
        option: function (user, escape) {
            return `<div class="d-flex flex-column">
                        <p class="mb-1"><span class="opacity-50">ID: </span>${user.friendly_id}</p>
                        <p class="mb-1"><span class="opacity-50">EmaiL: </span>${user.email}</p>
                        <p class="m-0"><span class="opacity-50">Name: </span>${escape(user.first_name)} ${escape(user.last_name)}</p>
                    </div>`;
        }
    }
}

export function initTomSelect(el) {
    import('tom-select').then((module) => {
        const settings = {
            createOnBlur: el.dataset.tomSelectCreate !== undefined,
            create: el.dataset.tomSelectCreate !== undefined,
            addPrecedence: el.dataset.tomSelectAddPrecedence !== undefined,
        }

        if (el.multiple) {
            settings.plugins = ['remove_button']
            settings.maxItems = el.dataset.tomSelectMaxItems !== undefined ? el.dataset.tomSelectMaxItems : null
        }

        if (el.dataset.tomSelectUrl) {
            settings.options = []
            const targetURL = new URL(el.dataset.tomSelectUrl, window.location.origin)
            settings.valueField = el.dataset.tomSelectValueField || 'pk'
            settings.labelField = el.dataset.tomSelectLabelField || 'name'
            settings.searchField = el.dataset.tomSelectLabelField
            settings.load = function (query, callback) {
                targetURL.searchParams.set("q", query)
                fetch(targetURL.toString())
                    .then(response => response.json())
                    .then(json => {
                        callback(json.results);
                    }).catch(() => {
                    callback();
                });
            }
        }

        if (el.dataset.tomSelectRender)
            settings.render = TomSelectTemplate[el.dataset.tomSelectRender]

        new module.default(el, settings);
    })
}